import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'

// material-ui(v5)
export const SidebarLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.fontSize, // 16px
}))
